import { featureCards } from "@/lib/data/features";
import { FeatureCard } from "./FeatureCard";

export function FeatureGrid() {
  return (
    <section className="w-full flex-1 ">
      <div className="container mx-auto">
        {/* Mobile: 2 columns, Tablet: 3 columns, Desktop: 4 columns, Large: 5 columns */}
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3 md:grid-cols-4 md:gap-4 lg:grid-cols-5">
          {featureCards.map((feature) => (
            <FeatureCard key={feature.id} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
}
